import React from 'react';
import { Box, useTheme } from '@mui/material';

/** Pixel “watchlist average” mark — same shape as MovieDetail metadata row */
const WatchlistCommunityRatingIcon: React.FC<{ size?: number; forDarkOverlay?: boolean }> = ({
  size = 20,
  forDarkOverlay = false,
}) => {
  const theme = useTheme();
  const fill = forDarkOverlay
    ? 'rgba(255, 255, 255, 0.92)'
    : theme.palette.mode === 'dark'
      ? '#E7E1F3'
      : '#232127';

  return (
    <Box
      sx={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
      aria-hidden
    >
      <svg width={size} height={size} viewBox="0 0 72 72" fill="none">
        <path
          d="M49 44H44V39H39V34H44V29H49V24H54V29H59V34H64V39H59V44H54V49H49V44Z"
          fill={fill}
        />
        <path
          d="M19 44H14V39H9V34H14V29H19V24H24V29H29V34H34V39H29V44H24V49H19V44Z"
          fill={fill}
        />
      </svg>
    </Box>
  );
};

export default WatchlistCommunityRatingIcon;
